import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AlertSnackbar from '../../common/AlertSnackbar';
import { useAppStatus } from '../appStatus';

/**
 * Persistent warning shown while SignalR keeps failing to connect. Kept apart from AlertContext so
 * other alerts can't replace it. Reopens each time the connection fails again after being dismissed.
 */
const ConnectionFailedAlert = () => {
  const { t } = useTranslation();
  const { connectionFailed } = useAppStatus();
  const [dismissed, setDismissed] = useState(false);
  const [wasFailed, setWasFailed] = useState(connectionFailed);
  if (wasFailed !== connectionFailed) {
    setWasFailed(connectionFailed);
    setDismissed(false);
  }

  return (
    <AlertSnackbar
      open={connectionFailed && !dismissed}
      onClose={() => setDismissed(true)}
      message={t('signalrConnectionFailed')}
      title={t('connectionIssue')}
      alertLevel='warn'
      autoHideDuration={null}
    />
  );
};

export default ConnectionFailedAlert;
